/* ============================================================
   PLUSHIE PATCH — collection page interactions
   ============================================================ */
(function () {
  "use strict";
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    /* ----- toast ----- */
    var tt;
    function toast(m) {
      var t = document.getElementById('toast');
      if (!t) { t = document.createElement('div'); t.className = 'toast'; t.id = 'toast'; document.body.appendChild(t); }
      t.textContent = m; t.classList.add('show');
      clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('show'); }, 2400);
    }

    /* ----- real Shopify sort (reload with sort_by param) ----- */
    window.ppSort = function (value) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page'); // back to page 1 on re-sort
      window.location.href = url.toString();
    };

    /* ----- grid density ----- */
    window.ppDensity = function (n) {
      var grid = document.getElementById('grid');
      if (grid) grid.classList.toggle('cozy', n === 3);
      var g4 = document.getElementById('g4'), g3 = document.getElementById('g3');
      if (g4) g4.classList.toggle('on', n === 4);
      if (g3) g3.classList.toggle('on', n === 3);
    };

    /* ----- wishlist heart ----- */
    window.ppWish = function (b) {
      b.classList.toggle('on');
      b.textContent = b.classList.contains('on') ? '♥' : '♡';
    };

    /* ----- quick add to cart (real) ----- */
    function addVariant(id, name) {
      if (!id) { toast('Choose options on the product page 🧸'); return; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        toast('Added to your cuddle cart 🧸');
      })
      .catch(function () { toast('Hmm — try the product page'); });
    }
    window.ppQuickAdd = function (id, name) { addVariant(id, name); };
    window.ppNotify = function (b) { b.textContent = "✓ We'll email you!"; toast("You're on the restock list 💌"); };

    /* ----- jump-out story popup (reads data-* from the card) ----- */
    window.ppOpenStory = function (box) {
      var modal = document.getElementById('storyModal');
      var plush = document.getElementById('storyPlush');
      plush.style.animation = 'none'; void plush.offsetWidth; plush.style.animation = '';
      plush.src = box.getAttribute('data-img');
      plush.alt = box.getAttribute('data-name');
      document.getElementById('storyName').textContent = box.getAttribute('data-short');
      document.getElementById('storyText').textContent = '\u201C' + box.getAttribute('data-story') + '\u201D';
      var addBtn = document.getElementById('storyAdd');
      var available = box.getAttribute('data-available') === 'true';
      var id = box.getAttribute('data-id');
      var url = box.getAttribute('data-url');
      var name = box.getAttribute('data-name');
      if (available) {
        addBtn.textContent = 'Take me home 🏡';
        addBtn.onclick = function () { addVariant(id, name); ppCloseStory(); };
      } else {
        addBtn.textContent = '🔔 Notify me';
        addBtn.onclick = function () { ppCloseStory(); toast("You're on the restock list 💌"); };
      }
      modal.classList.add('show');
    };
    window.ppCloseStory = function () {
      var m = document.getElementById('storyModal');
      if (m) m.classList.remove('show');
    };
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.ppCloseStory(); });
  }
})();
